import { Controller } from "@hotwired/stimulus";

// Opens an App Bridge <ui-modal> that was injected via a Turbo Stream, then
// removes it from the DOM once the merchant closes it so it doesn't stack up.
export default class extends Controller {
  connect() {
    const modal = this.element.querySelector("ui-modal");
    if (!modal) return;

    const open = () => {
      try {
        modal.show();
      } catch (e) {
        /* ui-modal not available (e.g. outside the embedded admin) */
      }
    };

    if (window.customElements && customElements.get("ui-modal")) {
      requestAnimationFrame(open);
    } else if (window.customElements) {
      customElements.whenDefined("ui-modal").then(open);
    }

    modal.addEventListener("hide", () => this.element.remove());
  }
}
